import cls from 'clsx';
import { Swiper } from '@linktivity/link-ui';
import { MAIN_WIDTH } from '@link/share/constants';
import { useIsMobile } from '@link/share/hooks';
import Img from '../Img';
import styles from './images.module.css';

interface ImagesProps {
  images: string[];
  urls?: string[];
  fullWidth?: boolean;
  alt?: string;
  className?: string;
  showArrowOnMobile?: boolean;
}

const Images: React.FC<ImagesProps> = ({
  images,
  urls,
  fullWidth = false,
  alt = 'Product',
  className,
  showArrowOnMobile = true
}) => {
  const isMobile = useIsMobile();
  const sizes = isMobile || fullWidth ? '100vw' : `${MAIN_WIDTH}px`;

  if (!images.length) return null;

  if (images.length === 1) {
    const image = images[0];
    const url = urls?.[0];
    const imgEl = (
      <Img src={image} alt={alt} className={className} sizes={sizes} />
    );
    return (
      <div
        className={cls(styles.swiper, fullWidth && styles.fullWidth, className)}
      >
        {url ? (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {imgEl}
          </a>
        ) : (
          imgEl
        )}
      </div>
    );
  }

  const firstImage = images[0];
  const lastImage = images[images.length - 1];
  const swiperKey = `${images.length}:${firstImage}:${lastImage}`;

  return (
    <Swiper
      key={swiperKey}
      className={cls(styles.swiper, fullWidth && styles.fullWidth, className)}
      loop={images.length > 2}
      loopedSlides={images.length - 1}
      showArrow={showArrowOnMobile || !isMobile}
    >
      {images.map((image, index) => {
        const url = urls?.[index];
        const imgEl = <Img src={image} alt={alt} sizes={sizes} />;
        return (
          <Swiper.Slide key={`${image}-${index}`} className={styles.image}>
            {url ? (
              <a href={url} target="_blank" rel="noopener noreferrer">
                {imgEl}
              </a>
            ) : (
              imgEl
            )}
          </Swiper.Slide>
        );
      })}
    </Swiper>
  );
};

export default Images;
